export default "__VITE_ASSET__veK6aRok__"